<template>
  <div class="contract-rule-item-bd">
    <div class="content-wrap">
      <div class="aside">
        <div class="title">{{ $t('crm_contract_rule_item.gui_ze_ji_ben_xin_xi') }}</div>
        <div class="info">
          <el-form ref="form" label-position="top">
            <el-form-item :label="$t('crm_contract_rule_item.chan_pin_xing_hao')">
              <custom-select
                :disabled="type === 'edit'"
                v-model="productCode"
                :multiple="true"
                url="productCodeRuleSelectList"
                :props="{ label: 'productName', value: 'productCode' }"
                :placeholder="$t('Common.com_please_select')"
                width="223px"
              ></custom-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="content">
        <div class="title">{{ $t('crm_contract_rule_item.gui_ze_xiang_qing') }}</div>
        <ul>
          <li v-for="(ruleItem, index) in ruleList" :key="index">
            <div class="tit">{{ ruleItem.name }}</div>
            <div class="sub" :class="{ 'is-required': index < 1 }" v-html="formatRule(ruleItem)"></div>
            <div class="list" v-for="(rule, idx) in ruleItem.rules" :key="idx">
              <div class="and-type ub">
                <div class="ub-f1">
                  <el-radio-group v-model="rule.connectSymbol" style="margin-left: 18px">
                    <el-radio :label="0">{{ $t('crm_contract_rule_item.ren_yi_tiao_jian') }}</el-radio>
                    <el-radio :label="1">{{ $t('crm_contract_rule_item.suo_you_tiao_jian') }}</el-radio>
                  </el-radio-group>
                </div>
                <div class="icon-box" style="line-height: 50px; margin-right: 10px" @click="delRule(ruleItem.rules, idx)">
                  <i class="icon icon-shanchu"></i>
                </div>
              </div>
              <div class="and-rule">
                <div class="rule-item ub" v-for="(items, i) in rule.children" :key="i">
                  <el-row :gutter="10" class="ub-f1">
                    <el-col :span="6">
                      <custom-select v-model="items.type" code="crm_sharing_rule_condition_type" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                    </el-col>
                    <el-col :span="6">
                      <custom-select v-model="items.symbol" code="isynergy_cloud_symbol" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                    </el-col>
                    <el-col :span="12">
                      <el-input type="number" v-model="items.value" :placeholder="$t('Common.com_please_input')" style="width: 100%"></el-input>
                    </el-col>
                  </el-row>
                  <div class="icon-box" @click="delSymbol(rule.children, i)">
                    <i class="icon icon-shanchu"></i>
                  </div>
                </div>
                <div class="add-child-btn" @click="addSymbol(rule.children)">
                  <div style="display: inline-block">
                    <i class="icon icon-add"></i>
                    <span>{{ $t('crm_contract_rule_item.tjtjfw') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 产品说不要了 -->
            <!-- <div class="role-add-btn" @click="addRule(ruleItem.rules)">
              <div style="display: inline-block">
                <i class="icon icon-add"></i>
                <span>{{ $t('p_contractruleAdd_tjtj') }}</span>
              </div>
            </div> -->
          </li>
        </ul>
      </div>
    </div>
    <div class="btn-group">
      <div class="btn" @click="jump(-1)">{{ $t('Common.com_cancel') }}</div>
      <div class="btn ok" @click="saveRule">{{ $t('Common.com_save') }}</div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'contract_rule_item',
  data() {
    return {
      type: '',
      editProductCode: '',
      itemForm: {
        sharingCondition: '',
        sharingType: '',
      },
      ruleList: [],
      productCode: [],
      conditionTypeMap: {},
      ruleInfo: {},
    };
  },
  mounted: function () {
    this.editProductCode = this.getJump('productCode') || '';
    this.type = this.editProductCode ? 'edit' : 'add';
    this.getRuleInfo();
  },
  methods: {
    // 获取详情
    getRuleInfo: function () {
      if (this.type === 'add') {
        this.initRule();
        return;
      }
      this.productCode = [this.editProductCode];
      this.$getJSON(apis.SharingRuleInfo, { productCode: this.editProductCode }).then((res) => {
        this.ruleInfo = res.data;
        this.initRule(res.data);
      });
    },
    // 初始化规则
    initRule: function (result = []) {
      this.getDictionary('crm_sharing_rule_type,crm_sharing_rule_condition_type', (data) => {
        this.conditionTypeMap = this.$transformDicValue(data.crm_sharing_rule_condition_type);
        const list = data.crm_sharing_rule_type; // 规则方案
        list.forEach((items) => {
          const row = result.find((t) => t.sharingClass === items.value) || {};
          items.sharingRuleId = row.sharingRuleId || ''; // 编辑需要带回该参数
          const sharingCondition = row.sharingCondition || ''; // 规则字符串
          const ruleItems = sharingCondition.split('OR');
          const rules = ruleItems.map((item) => {
            const connectSymbol = item.includes('&') ? 1 : 0;
            const listStr = connectSymbol === 1 ? item.split('&') : item.split('||');
            const children = listStr.map((t) => {
              const str = t
                .replace('(', '')
                .replace(')', '')
                .replace(/^\s+|\s+$/g, '');
              const arr = str.split(' ');
              return {
                type: arr[0] || '',
                symbol: arr[1] || '',
                value: arr[2] || '',
              };
            });
            return { connectSymbol, children };
          });
          this.$set(items, 'rules', rules);
        });
        this.ruleList = list;
      });
    },
    // 添加条件范围
    addSymbol: function (item) {
      item.push({ type: '', symbol: '', value: '' });
    },
    // 删除条件范围
    delSymbol: function (item, index) {
      item.splice(index, 1);
    },
    // 添加条件
    addRule: function (rules) {
      rules.push({
        connectSymbol: 0,
        children: [{ type: '', symbol: '', value: '' }],
      });
    },
    // 删除条件
    delRule: function (item, index) {
      item.splice(index, 1);
    },
    // 文字显示
    formatRule: function (data) {
      const str = this.$t('crm_contract_rule_item.qtxgztj');
      const ruleStr = [];
      const ruleCode = [];

      data.rules.forEach((item) => {
        const list = item.children.filter((t) => t.type && t.symbol && t.value);
        const row = list.map((t) => `${this.conditionTypeMap[t.type]} ${t.symbol} ${t.value}`);
        const row1 = list.map((t) => `${t.type} ${t.symbol} ${t.value}`);
        const tip = row.join(item.connectSymbol ? ' & ' : ' || ');
        const tip1 = row1.join(item.connectSymbol ? ' & ' : ' || ');
        if (tip) {
          ruleStr.push(`(${tip})`);
        }
        if (tip1) {
          ruleCode.push(`(${tip1})`);
        }
      });
      data.ruleCode = ruleCode.join('OR');
      data.ruleStr = ruleStr.join('OR');
      return ruleStr.join('<p>OR</p>') || str;
    },
    // 保存规则
    saveRule: function () {
      if (!this.productCode.length) {
        this.$message.error(this.$t('crm_contract_rule_item.qxzcpxh'));
        return;
      }
      let isFinish = true;
      let validCount = 0;
      let invalidCount = 0;
      this.ruleList.forEach((item) => {
        if (!item.rules.length) {
          isFinish = false;
          return;
        }
        item.rules.forEach((val) => {
          const list = val.children.filter((t) => t.type && t.symbol && t.value);
          validCount += list.length;
          const list2 = val.children.filter((t) => !((t.type && t.symbol && t.value) || (!t.type && !t.symbol && !t.value)));
          invalidCount += list2.length;
        });
      });
      isFinish = validCount > 0 && invalidCount <= 0 && isFinish;
      if (!isFinish) {
        this.$message.error(this.$t('crm_contract_rule_item.qjgztxwc'));
        return;
      }
      if (this.type === 'add') {
        this.onInsert();
      }
      if (this.type === 'edit') {
        this.onUpdate();
      }
    },
    // 新增规则
    onInsert: function () {
      const conditionList = this.ruleList
        .filter((t) => t.ruleCode)
        .map((t) => ({
          productCode: this.productCode.join(','),
          sharingClass: t.value,
          sharingCondition: t.ruleCode,
        }));
      this.$postJSON(apis.SharingRuleAdd, conditionList).then(() => {
        this.clearTagByKeep('contract_rule_item');
        this.jump('/offer/contractrule', {}, true);
      });
    },
    // 更新规则
    onUpdate: function () {
      const conditionList = this.ruleList
        .filter((t) => t.ruleCode)
        .map((t) => ({
          productCode: this.productCode.join(','),
          sharingClass: t.value,
          sharingCondition: t.ruleCode,
          sharingRuleId: t.sharingRuleId,
        }));
      this.$postJSON(apis.SharingRuleUpdate, conditionList).then(() => {
        this.clearTagByKeep('contract_rule_item');
        this.jump('/offer/contractrule', {}, true);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';

.contract-rule-item-bd {
  background-color: #ffffff;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 80px;
  .btn-group {
    height: 80px;
    text-align: center;
    background-color: #f2f2f2;
    padding-top: 20px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    .btn {
      cursor: pointer;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
      width: 110px;
      background-color: #ffffff;
      color: #1e1e1e;
      font-size: 14px;
      &.ok {
        margin-left: 10px;
        background-color: #00afff;
        color: #ffffff;
      }
    }
  }
  .content-wrap {
    width: 1100px;
    margin: 0 auto;
    display: flex;
    .title {
      color: #262626;
      font-size: 16px;
      padding: 20px 0;
    }

    .aside {
      width: 242px;
      border-right: 1px solid #e4e4e4;
      .el-form-item--small.el-form-item {
        margin-bottom: 8px;
      }
    }
    .content {
      flex: 1;
      width: 0;
      padding: 0 0 56px 20px;
      .role-add-btn {
        background: rgba(245, 245, 245, 1);
        border: 1px solid rgba(228, 228, 228, 1);
        line-height: 40px;
        text-align: center;
        color: #333333;
        font-size: 12px;
        margin-top: 10px;
        cursor: pointer;
        .icon {
          color: #00afff;
          font-size: 10px;
          margin-right: 8px;
          float: left;
        }
      }
      ul li {
        border: 1px solid rgba(228, 228, 228, 1);
        position: relative;
        margin-top: 24px;
        padding: 24px 30px;
        .tit {
          width: 42px;
          text-align: center;
          background-color: #ffffff;
          position: absolute;
          line-height: 45px;
          color: #00afff;
          font-size: 32px;
          font-weight: bold;
          top: -23px;
          left: 20px;
        }
        .sub {
          color: #818181;
          font-size: 12px;
          line-height: 30px;
          margin-bottom: 25px;
          &.is-required::before {
            content: '*';
            color: #ff3a3a;
            float: left;
            margin-right: 4px;
          }
        }
        .list {
          border: 1px solid rgba(228, 228, 228, 1);
          margin-bottom: 10px;
          .and-type {
            background-color: #f5f5f5;
            line-height: 50px;
            border-bottom: 1px solid rgba(228, 228, 228, 1);
          }
          .and-rule {
            padding: 14px 10px;
          }
        }
        .rule-item {
          margin-bottom: 5px;
        }
        .icon-box {
          line-height: 30px;
          width: 30px;
          margin-left: 10px;
          text-align: center;
          .icon {
            color: #00afff;
            font-size: 14px;
            cursor: pointer;
          }
        }
        .add-child-btn {
          background: rgba(245, 245, 245, 1);
          border: 1px dashed rgba(228, 228, 228, 1);
          line-height: 30px;
          text-align: center;
          color: #333333;
          font-size: 12px;
          margin-top: 10px;
          cursor: pointer;
          .icon {
            color: #00afff;
            font-size: 10px;
            margin-right: 8px;
            float: left;
          }
        }
      }
    }
  }
}
</style>
